import 'jquery.cookie';
import 'jcarousel';

import Vue from 'vue';
import useVueCompositionApi from '@/js/common/plugins/use-vue-composition-api';

import SearchPageAbstract from '@/js/desktop/View/Abstract/SearchPageAbstract';

import { DesktopSerpFilters } from '@widgets/serpHotelOffersProducts/desktop';
import hotelOffersHotelCategoiesList
    from '@ve/components/filters/hotelCategoriesFilter/common/hotelOffersHotelCategoiesList';
import HotelOnMapHotelOfferView from './hotelOnMap/HotelOnMapHotelOfferView';

export default class SearchPageHotelOffersList extends SearchPageAbstract {
    initScrolPagination() {
        let bottomListElement = $('#eop');

        $(window).scroll(() => {
            const scrollTopPosition = $(document).scrollTop();
            const windowHeight = $(window).height();

            this.model.set('scrollPosition', scrollTopPosition);

            if (!bottomListElement.length) {
                bottomListElement = $('#eop');
            }

            if (bottomListElement.length && bottomListElement.is(':visible') && scrollTopPosition + windowHeight + 320 > bottomListElement.position().top) {
                this.pageInc();
            }
        });
    }

    initDomEvents() {
        super.initDomEvents();
        this.initScrolPagination();
    }

    HotelOnMapViewConstructor() {
        return HotelOnMapHotelOfferView;
    }

    async initHotelMapView() {
        const { default: HotelsMapView } = await import(/* webpackChunkName: "HotelsMapView" */ './hotelsMap/HotelsMap');
        return HotelsMapView;
    }

    initVueComponents() {
        useVueCompositionApi();
        this.initFilters();
        this.initRefreshLoader();
    }

    initFiltersComponent(store) {
        return new Vue({
            name: 'FiltersListSerp',
            render: (h) => h(DesktopSerpFilters, {
                props: {
                    categoriesList: hotelOffersHotelCategoiesList,
                },
            }),
            store,
        }).$mount('.filters-list-serp');
    }
}
